<template>

         <div class="peoplemap-part"> 
            <div id="viewer" class="viewer" style="width: 100vw; height: 100vh;"></div>
            <div id="container"></div>

            <div class="open-box"  v-show="openbox" >
                <div class="hide-close-background"></div>
                <div class="open-box-main" >
                    <a href="javascript:;"  class="closeopenbox-btn">關閉資訊</a>
                    <div class="map-box">
                        <img :src="PicturePath(this.datatext[0].allmap)">
                    </div>
                    <div class="open-inf-box">
                        <div class="area">{{this.datatext[0].bigarea}}</div>
                        <div class="name">{{this.datatext[0].mainarea}}</div>
                        <div class="inf">
                            {{this.data00[0].inf}}
                        </div>
                        <div class="spot-sounds">
                            <div class="sounds-btns">
                                <a href="javascript:;" class="sounds-box1-btn">{{this.datatext[0].soundtext}}</a> 
                                <a href="javascript:;" class="sounds-box2-btn">客語介紹</a>
                            </div>
                            <div class="all-sounds-box">
                                <div class="sounds-box1">
                                    <audio id="audio1" controls :src="Sounds(this.data00[0].sound1)" controlsList="nodownload noplaybackrate"></audio>
                                </div> 
                                <div class="sounds-box2">
                                    <audio id="audio2" controls :src="Sounds(this.data00[0].sound2)" controlsList="nodownload noplaybackrate"></audio>
                                </div> 
                            </div>                    
                        </div>
                        <div class="open-link-box">
                                <router-link to="/location01"  class="open-link-btn">
                                    <div class="menu-img-box">
                                        <div class="menu-img">
                                            <img :src="PicturePath(this.data01[0].mainimg)">
                                        </div>
                                        <span>{{this.data01[0].name}}</span>
                                    </div>
                                </router-link>
                                <router-link to="/location02"  class="open-link-btn">
                                    <div class="menu-img-box">
                                        <div class="menu-img">
                                            <img :src="PicturePath(this.data02[0].mainimg)">
                                        </div>
                                        <span>{{this.data02[0].name}}</span>
                                    </div>
                                </router-link>
                                <router-link to="/location03"  class="open-link-btn">
                                    <div class="menu-img-box">
                                        <div class="menu-img">
                                            <img :src="PicturePath(this.data03[0].mainimg)">
                                        </div>
                                        <span>{{this.data03[0].name}}</span>
                                    </div>
                                </router-link>
                                <router-link to="/location04"  class="open-link-btn">
                                    <div class="menu-img-box">
                                        <div class="menu-img">
                                            <img :src="PicturePath(this.data04[0].mainimg)">
                                        </div>
                                        <span>{{this.data04[0].name}}</span>
                                    </div>
                                </router-link>
                                <router-link to="/location05"  class="open-link-btn">
                                    <div class="menu-img-box">
                                        <div class="menu-img">
                                            <img :src="PicturePath(this.data05[0].mainimg)">
                                        </div>
                                        <span>{{this.data05[0].name}}</span>
                                    </div>
                                </router-link>                                                                                                                                
                        </div>
                    </div>
                </div>
            </div>
        </div>


</template>

<script>




import { Viewer } from '@photo-sphere-viewer/core';
import { MarkersPlugin } from '@photo-sphere-viewer/markers-plugin';
import { VisibleRangePlugin } from '@photo-sphere-viewer/visible-range-plugin';
import * as PANOLENS from 'panolens'
import $ from 'jquery';

export default {
    name: 'App',
    data() {
        return {
            openbox:false
    
        };
    },
    methods: {
      
     

    },
    mounted() {

            /*
            const animatedValues = {
                    pitch: { start: -Math.PI / 2, end: 0.2 },
                    yaw: { start: Math.PI, end: 0 },
                    zoom: { start: 0, end: 50 },
                    fisheye: { start: 2, end: 0 },
            };

            const viewer = new Viewer({
                container: document.querySelector('#viewer'),
                panorama: 'images/01.jpg',
                defaultPitch: -Math.PI / 2,
                defaultYaw: Math.PI,
                defaultZoomLvl: 0,
                fisheye: 2,
                navbar: [
                    'autorotate',
                    'zoom',
                    {
                        title: 'Rerun animation',
                        content: '🔄',
                        onClick: intro,
                    },
                    'caption',
                    'fullscreen',
                ],
                plugins: [
                    [AutorotatePlugin, {
                        autostartDelay: null,
                        autostartOnIdle: false,
                        autorotatePitch: 0.2,
                    }],
                ],
    
            });

            const autorotate = viewer.getPlugin(AutorotatePlugin);

            viewer.addEventListener('ready', intro, { once: true });
            function intro() {
                autorotate.stop();

                new Animation({ // eslint-disable-line
                    properties: animatedValues,
                    duration: 2500,
                    easing: 'inOutQuad',
                    onTick: (properties) => {
                        viewer.setOption('fisheye', 0);
                        viewer.rotate({ yaw: properties.yaw, pitch: properties.pitch });
                        viewer.zoom(properties.zoom);
                    },
                }).then(() => {
                    autorotate.start();
                });
            }
            */




             const viewer = new Viewer({
                container: document.querySelector('#viewer'),
                panorama: 'images/0-2-min.JPG',
                defaultPitch: Math.PI / 1,
                defaultYaw: -1,
                defaultZoomLvl:0,
                fisheye: 2,
                loadingImg:'images/loading.jpg',
                navbar: [
                ],

                plugins: [

                    [MarkersPlugin, {
                    // list of markers
                    markers: [

                      
                        {
                            id: 'location0_1',
                            position: {
                                "yaw": 1.746,
                                "pitch": -0.346
                            },
                            html: '<div class="level1-btn"><div class="btn-title">'+this.data01[0].name+'</div></div>',
                            scale: [1, 1],
                            hoverScale: 1.1,
                        },
                       {
                            id: 'location0_2',
                            position: {
                                "yaw": 0.128,
                                "pitch": 0.033
                            },
                            html: '<div class="level1-btn"><div class="btn-title">'+this.data02[0].name+'</div></div>',
                            scale: [1, 1],
                            hoverScale: 1.1,

                        },
                        {
                            id: 'location0_3',
                            position: {
                                "yaw": 1.201,
                                "pitch": 0.03
                            },
                            html: '<div class="level1-btn"><div class="btn-title">'+this.data03[0].name+'</div></div>',
                            scale: [1, 1],
                            hoverScale: 1.1,

                        },      
                        {
                            id: 'location0_4',
                            position: {
                                "yaw": 4.247,
                                "pitch": 0.046
                            },
                            html: '<div class="level1-btn"><div class="btn-title">'+this.data04[0].name+'</div></div>',
                            scale: [1, 1],
                            hoverScale: 1.1,

                        },   
                        {
                            id: 'location0_5',
                            position: {
                                "yaw": 1.665,
                                "pitch": 0.15
                            },
                            html: '<div class="level1-btn"><div class="btn-title">'+this.data05[0].name+'</div></div>',
                            scale: [1, 1],
                            hoverScale: 1.1,

                        },   

                    ],
                    
                    }],
                    [VisibleRangePlugin, {
                        //verticalRange: [Math.PI / 1, Math.PI / 1],
                    }],
                ],
            });
            const markersPlugin = viewer.getPlugin(MarkersPlugin);
             

            markersPlugin.addEventListener('select-marker', ({ marker }) => {
                
                //console.log(`Clicked on marker ${marker.id}`);
                    if (marker.id === 'location0_1') {
                            this.$router.push('/location01');     
                    }
                    if (marker.id === 'location0_2') {
                            this.$router.push('/location02');
                    }
                    if (marker.id === 'location0_3') {
                            this.$router.push('/location03');    
                    }
                    if (marker.id === 'location0_4') {
                            this.$router.push('/location04');  
                    }
                    if (marker.id === 'location0_5') {
                            this.$router.push('/location05');   
                    }
                                                                                                         
            });

            viewer.addEventListener('ready', () => {
                markersPlugin.hideMarker('location0_1');  
                markersPlugin.hideMarker('location0_2'); 
                markersPlugin.hideMarker('location0_3'); 
                markersPlugin.hideMarker('location0_4'); 
                markersPlugin.hideMarker('location0_5'); 

                viewer
                    .animate({
                        yaw: Math.PI / 2,
                        pitch: '-10deg',
                        zoom: 60,
                        speed: '8rpm',
                    })
                    .then(() => {
                        markersPlugin.showMarker('location0_1');  
                        markersPlugin.showMarker('location0_2');  
                        markersPlugin.showMarker('location0_3');  
                        markersPlugin.showMarker('location0_4');  
                        markersPlugin.showMarker('location0_5');  

                        this.openbox = true
                        $('.open-box').fadeIn(1200);
                    });

            }, { once: true });
              
            //vr盒
            var panorama, viewer2, container;
            container = document.querySelector( '#container' );
            panorama = new PANOLENS.ImagePanorama( 'images/0-2-min.JPG' );
            viewer2 = new PANOLENS.Viewer( { container: container } );
            viewer2.enableEffect( PANOLENS.MODES.STEREO ); 
            viewer2.add( panorama);
          

            $('.hide-close-background').on('click', function (e) {
                $('.open-box').fadeOut(500);
            });

            $('.closeopenbox-btn').on('click', function (e) {
                $('.open-box').fadeOut(500);
            });

            var allAudios = document.querySelectorAll('audio');

            $('.sounds-box1-btn').on('click', function (e) {
                $('.all-sounds-box').fadeIn(300);
                $('.sounds-box2').fadeOut(300);
                $('.sounds-box1').fadeIn(300);
                $('.sounds-box2-btn').removeClass("current");
                $('.sounds-box1-btn').addClass("current");
                allAudios.forEach(function(audio){
                    audio.pause();
                });
            });
            $('.sounds-box2-btn').on('click', function (e) {
                $('.all-sounds-box').fadeIn(300);
                $('.sounds-box1').fadeOut(300);
                $('.sounds-box2').fadeIn(300);
                $('.sounds-box2-btn').addClass("current");
                $('.sounds-box1-btn').removeClass("current");
                allAudios.forEach(function(audio){
                    audio.pause();
                });
            });


        }
}
</script>


<style scoped>

</style>
